// TODO consider other way.
import { html } from 'lit-html';
import icons from "@giswebgroup/ki-wcp-base/src/common/allicons.json"
import {unsafeHTML} from 'lit-html/directives/unsafe-html.js';

export function StatusIcon(image, label= '', col) {
  return html`
        <div class="cell col-__tag" style="${col.css || ''}text-align: center">
            <img src='${image}' alt='${label}' title='${label}'/>
        </div>`
}

function getIcon(iconClass, color) {
  const icon = icons[iconClass];
  if(!icon){
    return "";
  }
  return icon.replace("<svg ", `<svg style='fill:${color};width:14px;vertical-align: top;'`)

}
export function Status(args = {}) {
  const { icon, label, color, backgroundColor, showLabelInTable } = args

  const statusstyle1 = `
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
  background-color: ${backgroundColor};
  color:${color};
  width: 17px;
`;
  const statusstyle2 = `
    padding: 5px;
    border-radius: 4px;
    white-space: nowrap;
    background-color: ${backgroundColor};
    color:${color};
    text-overflow: ellipsis;
    overflow:hidden;
  `;
  return html`
    <div class="cell status">
      ${args
        ? html`
            <div style="${showLabelInTable ? statusstyle2 : statusstyle1}" title="${label || ''}">
              ${unsafeHTML(getIcon(icon, color))}
              <span style="padding: 0 4px;color:black;">${showLabelInTable ? label : ""}</span>
            </div>
          `
        : html` <div style="text-align: center;">-</div> `}
    </div>
  `;
}
